import { Controller } from "@hotwired/stimulus"
import Tags from "bootstrap5-tags";

// Connects to data-controller="task-people"
export default class extends Controller {
  static targets = [ "element" ]
  connect() {
    Tags.init("#" + this.elementTarget.id, {
      allowClear: true,
      server: this.elementTarget.dataset.server,
      liveServer: true,
      labelField: this.elementTarget.dataset.labelfield || 'name',
      valueField: this.elementTarget.dataset.valuefield || 'id',
      searchFields: this.elementTarget.dataset.searchfields ? [this.elementTarget.dataset.searchfields] : ['name']
    });
  }
} 